import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00b3e63d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "nav-main" }
const _hoisted_3 = { class: "m-items" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(['navigation-bar', _ctx.transparent ? 'transparent' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.navItems)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (s) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (s.visible)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          class: _normalizeClass([s.status,  _ctx.transparent ? 'transparent' : '']),
                          onClick: $event => {_ctx.navigate(s);}
                        }, _toDisplayString(s.name), 11, _hoisted_5))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ]))
            : _createCommentVNode("", true)
        ]),
        _renderSlot(_ctx.$slots, "right-side-buttons", {}, undefined, true)
      ])
    ])
  ], 2))
}